"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaletteOverridesContext = exports.PaletteConfigContext = void 0;
var _react = require("react");
const PaletteConfigContext = /*#__PURE__*/(0, _react.createContext)(undefined);
exports.PaletteConfigContext = PaletteConfigContext;
const PaletteOverridesContext = /*#__PURE__*/(0, _react.createContext)({});
exports.PaletteOverridesContext = PaletteOverridesContext;